export default __webpack_public_path__ + "static/media/JJ-Gold-Logo-071519.1fe090d1.png";